import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/components/Box";
import CustomChip from "@memorang/ui/components/CustomChip";
import type { IconType } from "@memorang/ui/icon";
/* -----------------Child components--------------- */
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
export const SectionHeader = ({
	sectionTitle,
	chipProps,
	handleClickChips,
}: {
	sectionTitle: string;
	chipProps?: {
		label: string;
		icon: IconType;
		background?: string;
		textColor?: string;
		tooltip?: string;
	};
	handleClickChips?: () => void;
}) => {
	const { isMobile } = useDevice();

	const theme = useAppTheme();

	const chipTextColor = chipProps?.textColor ?? theme.colors.text;

	return (
		<Box
			justifyContent="space-between"
			alignItems="center"
			flexDirection="row"
			paddingVertical={8}
			paddingRight={isWeb && !isMobile ? 0 : 16}
		>
			<CustomListSubheaderContainer enableGutters={isMobile}>
				{sectionTitle}
			</CustomListSubheaderContainer>
			{chipProps && (
				<CustomChip
					onPress={handleClickChips}
					icon={chipProps.icon}
					iconColor={chipTextColor}
					style={{
						backgroundColor: chipProps.background,
					}}
					textStyle={{
						color: chipTextColor,
					}}
				>
					{chipProps.label}
				</CustomChip>
			)}
		</Box>
	);
};
